import { postCoachLecture } from '#api/lectures';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { Button, Textarea } from '#atoms';
import { usePriceInput } from '#hooks/usePriceInput';
import { LabeledInput } from '#molecules';
import { useToast } from '#providers/ToastProvider';
import { formatNumberWithCommas } from '#utils/Numbers';
import { useQueryClient } from '@tanstack/react-query';
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import {
  ButtonContainer,
  Container,
  ContentArea,
  ItemContainer,
  Label,
  RequiredMark
} from './styles';

const OnePoint = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [description, setDescription] = useState<string>('');
  const { price: pricePerRound, handlePriceInput } = usePriceInput(undefined);
  const [round, setRound] = useState<number | undefined>();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await handlePostButtonClick();
  };

  const handlePostButtonClick = async () => {
    try {
      if (pricePerRound === undefined) {
        throw new Error('가격을 입력해 주세요');
      }

      if (round === undefined) {
        throw new Error('횟수를 입력해 주세요');
      }
      await postCoachLecture({
        title: '원포인트 수업',
        rounds: round,
        isOnePoint: true,
        isOt: false,
        body: description,
        price: pricePerRound
      });

      await queryClient.invalidateQueries({
        queryKey: queryKeyFactory.GET_LECTURES()
      });
      showToast({
        message: '원포인트 수업 등록에 성공하였습니다.'
      });
      navigate(-1);
    } catch (err: any) {
      showToast({
        type: 'fail',
        message: '원포인트 수업 등록에 실패하였습니다.'
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <ContentArea>
          <ItemContainer>
            <Label>
              수업 소개<RequiredMark>*</RequiredMark>
            </Label>
            <Textarea
              height={15}
              limit={1000}
              placeholder="수업에 대해 소개해 주세요"
              value={description}
              onChange={e => setDescription(String(e))}
              // maxLength={29}
            />
            {/* <Text
              textStyle="c1"
              textColor="gray2"
              style={{ textAlign: 'right' }}
            >{`${description.length} / 30`}</Text> */}
          </ItemContainer>
          <ItemContainer>
            <LabelInput
              label="수업 횟수"
              placeholder="총 수업 횟수를 입력해 주세요"
              value={round !== undefined ? String(round) : ''}
              suffix="회"
              onInput={e =>
                setRound(e === '' || isNaN(Number(e)) ? undefined : Number(e))
              }
              required
            />
          </ItemContainer>
          <ItemContainer className="labeled">
            <LabelInput
              label="수업 가격"
              placeholder="총 수업 가격을 입력해 주세요"
              value={
                pricePerRound !== undefined
                  ? formatNumberWithCommas(pricePerRound)
                  : ''
              }
              suffix="원"
              onInput={handlePriceInput}
              required
            />
          </ItemContainer>
        </ContentArea>
      </Container>
      <ButtonContainer>
        <Button
          disabled={
            !description.length || pricePerRound === undefined || !round
          }
        >
          등록
        </Button>
      </ButtonContainer>
    </form>
  );
};

export default OnePoint;

const LabelInput = styled(LabeledInput).attrs(({ theme }) => ({
  textStyle: {
    color: theme.palette.gray25,
    fontWeight: 500
  }
}))``;
